import { Pipe, PipeTransform } from '@angular/core';

export interface PolicyIssueButtonContext  {
  premiumChangeList: any;
  noInvalidFormControl: boolean;
  hasPolicyChanges: boolean;
  approveAnyUser: boolean;
  issuePolicyFormValid: boolean;
  isPaid: boolean;
  isOutOfSequenceTransaction: boolean;
  isRaterCalculated: boolean;
  isEditPolicy: boolean;
  isCancelled: boolean;
  isExpired: boolean;
  uwrsIsDoneLoading: boolean;
  isExternalUser: boolean;
  isDoneLoadingChanges: boolean;
  isFromRenewal: boolean;
}

@Pipe({
  name: 'isIssueDisabled'
})
export class IsIssueDisabledPipe implements PipeTransform {
  transform(context: PolicyIssueButtonContext ): boolean {
    const {
      premiumChangeList,
      noInvalidFormControl,
      hasPolicyChanges,
      approveAnyUser,
      issuePolicyFormValid,
      isPaid,
      isOutOfSequenceTransaction,
      isRaterCalculated,
      isEditPolicy,
      isCancelled,
      isExpired,
      uwrsIsDoneLoading,
      isExternalUser,
      isDoneLoadingChanges,
      isFromRenewal
    } = context;

    const finalPremiumFees =
      premiumChangeList?.find(x => x.stepAlias === 'FPrePlusFee')?.premiumDiffChange;

    let isDisabled = true;

    const baseConditionsMet =
      isEditPolicy &&
      noInvalidFormControl &&
      hasPolicyChanges &&
      approveAnyUser &&
      issuePolicyFormValid &&
      isRaterCalculated &&
      uwrsIsDoneLoading &&
      isDoneLoadingChanges;

    if (baseConditionsMet) {
      if (finalPremiumFees === 0 || !isFromRenewal || (isPaid && isFromRenewal)) {
        isDisabled = false;
      }

      if (isCancelled) {
        isDisabled = true;
      } else if (isExpired) {
        isDisabled = isExternalUser;
      }
    }

    return isDisabled;
  }
}
